/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useCallback, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { connect } from 'react-redux';
import { Pagination } from 'antd-v5';
import ViewAll from '../../../../../../components/Routes/ClientsV2/components/ViewAll';
import QuickViewSkeletonCard from '../../components/QuickViewSkeletonCard';
import AppointmentCard from '../AppointmentCard';
import { getAppointment, getAppointmentsConfig, getClientAppointments } from '../../../../../../services/appointments';
import { getEvent } from '../../../../../../services/events';
import AddEditAppointment from '../AddEditAppointment';

const ViewAllAppointments = ({ setViewAllType, clientId, allAssoc }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editAppointment, setEditAppointment] = useState(null);
  const { data, isFetching, refetch } = useQuery(
    ['client-appointments', clientId, page, pageSize],
    async () => {
      const query = {
        limit: pageSize,
        offset: (page - 1) * pageSize,
      };
      return getClientAppointments(clientId, query);
    },
    {
      enabled: !!clientId,
      refetchOnWindowFocus: false,
      initialData: {
        data: [],
        limit: 5,
        offset: 0,
        total: 0,
      },
    },
  );

  const { data: appointmentsConfig } = useQuery(
    ['appointments-config'],
    async () => {
      return getAppointmentsConfig();
    },
    {
      refetchOnWindowFocus: false,
      initialData: {
        stores: [],
        appointmentTypes: [],
      },
    },
  );

  const eventIds = useMemo(() => [...new Set(data?.data?.map(a => a.eventId).filter(Boolean))], [data]);

  const { data: eventNames = {} } = useQuery(
    ['event-names', ...eventIds],
    async () => {
      const results = await Promise.all(
        eventIds.map(id => getEvent({ eventId: id, loadingStatusOff: true }).catch(() => null)),
      );
      const map = {};
      results.forEach(event => {
        if (event?.id) map[event.id] = event.name;
      });
      return map;
    },
    {
      enabled: eventIds.length > 0,
      refetchOnWindowFocus: false,
    },
  );

  const handleEditAppointment = useCallback(async appointment => {
    try {
      const response = await getAppointment(appointment.id);
      const fullAppointment = response?.data || response;
      setEditAppointment(fullAppointment);
    } catch (error) {
      console.error('Failed to fetch appointment details:', error);
      setEditAppointment(appointment);
    }
    setShowAddModal(true);
  }, []);

  const handleCloseAddAppointment = useCallback(() => {
    setShowAddModal(false);
    setEditAppointment(null);
  }, []);

  const handleAddAppointment = useCallback(() => {
    refetch();
  }, []);

  return (
    <ViewAll title="All Appointments" setViewAllType={() => setViewAllType(null)}>
      <div className="flex-col w-100-P gap-16">
        {isFetching ? (
          Array(5)
            .fill(null)
            .map((_, index) => <QuickViewSkeletonCard key={index} />)
        ) : data.total > 0 ? (
          <>
            {data?.data?.map(appointment => (
              <AppointmentCard
                key={appointment.id}
                {...appointment}
                allAssoc={allAssoc}
                eventName={appointment.eventId ? eventNames[appointment.eventId] : null}
                onAssignedSuccess={refetch}
                handleEdit={() => handleEditAppointment(appointment)}
                appointmentsConfig={appointmentsConfig}
              />
            ))}
            <div className="flex-row justify-end">
              <Pagination
                pageSizeOptions={[5, 10, 20]}
                current={page}
                pageSize={pageSize}
                total={data.total}
                onChange={page => setPage(page)}
                showSizeChanger
                onShowSizeChange={(current, size) => setPageSize(size)}
              />
            </div>
          </>
        ) : (
          <div>No appointments found</div>
        )}
      </div>
      <AddEditAppointment
        isOpen={showAddModal}
        clientId={clientId}
        onClose={handleCloseAddAppointment}
        onSuccess={handleAddAppointment}
        allAssoc={allAssoc}
        appointment={editAppointment}
        eventId={editAppointment?.event?.id}
        eventName={editAppointment?.event?.name}
        eventStartDate={editAppointment?.event?.startDate}
        eventEndDate={editAppointment?.event?.endDate}
        disableEventSelect={!!editAppointment?.event?.id}
      />
    </ViewAll>
  );
};

function mapStateToProps(state) {
  const { auth, client } = state;

  return {
    userId: auth.userId,
    clientId: client.id,
  };
}
export default connect(mapStateToProps, {})(ViewAllAppointments);
